import '@formatjs/intl-getcanonicallocales/polyfill'
import '@formatjs/intl-pluralrules/polyfill'
import '@formatjs/intl-relativetimeformat/polyfill'
import '@formatjs/intl-listformat/polyfill'
import '@formatjs/intl-displaynames/polyfill'
import '@formatjs/intl-numberformat/polyfill'
import '@formatjs/intl-datetimeformat/polyfill'
import '@formatjs/intl-datetimeformat/add-all-tz'
import '@formatjs/intl-locale/polyfill'
import React, { ReactElement, useContext } from 'react'
import { useSelector } from 'react-redux'
import { IntlProvider as ReactIntlProvider } from 'react-intl'
import { Translation, TranslationsKeys } from 'lib/types'
import { CoreContext } from 'lib/core/resources/context'
import { translations as coreTranslations } from 'lib/core/resources/translations'
import { getLocale } from 'lib/core/data/common/locale/selectors'

interface Props {
  children: ReactElement | ReactElement[]
}

export const IntlProvider = ({ children }: Props) => {
  const context = useContext(CoreContext)
  const locale = useSelector(getLocale)
  const messagesKeys: Record<string, TranslationsKeys> = {}
  const translations = context.translations ?? coreTranslations

  translations.forEach((locale: Translation) => {
    messagesKeys[locale.code] = locale.keys
  })

  return (
    <ReactIntlProvider
      locale={locale}
      messages={messagesKeys[locale]}
    >
      {children}
    </ReactIntlProvider>
  )
}
